
import React, { useEffect, useState } from 'react'
import Navbar from '../../components/Navbar'
import { Box, Button, CircularProgress, Container, Grid, Typography } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTheme } from '@emotion/react'
import useAxiosPrivate from '../../hooks/use-axios-private';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/reducers/auth-slice';
import useAuth from '../../hooks/use-auth';
import moment from 'moment';
import { APP_DATE_FORMAT } from '../../constants';



const PaymentSuccess = () => {
    const navigate = useNavigate()
    const theme = useTheme()
    const { user } = useAuth();
    const axios = useAxiosPrivate()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const paymentToken = searchParams.get('payment_token')
    const orderId = searchParams.get('token')
    const [isPaymentError, setIsPaymentError] = useState(false)
    const [transactionDetails, setTransactionDetails] = useState(false)
    const [orderItem, setOrderItem] = useState({
        create_time: "",
        value: "",
    })

    const navigateToWallet = () => {

        if (window.electron) {
            window.electron.navigateToWallet()
            return
        }
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(transactionDetails))
            return
        }
        window.postMessage(JSON.stringify(transactionDetails))
        window.close();
        // navigate('/wallet');
    }

    const capturePayment = async () => {
        try {
            const resp = await axios.post('/payments/capture/', { order_id: orderId }, {
                withCredentials: true,
                headers: {
                    'Authorization': `Bearer ${paymentToken}`
                }
            })
            setTransactionDetails(resp.data.data.paypal_response)
            console.log("🚀 ~ file: PaymentSuccess.jsx:35 ~ capturePayment ~ resp.data.data.paypal_response:", resp.data.data.paypal_response)
            setOrderItem(resp.data.data.paypal_response.purchase_units.find(x => x.reference_id === 'default').payments.captures[0])
            dispatch(authActions.grantLoginAccess({
                user: { ...resp.data.data.user },
                isLoggedIn: true
            }));
        }
        catch (err) {
            setIsPaymentError(true)
            window.ReactNativeWebView &&
                window.ReactNativeWebView.postMessage(JSON.stringify(err.response));
            console.error("🚀 ~ file: PaymentModal.jsx:34 ~ getClientToken ~ err:", err)
        }
    }

    useEffect(() => {
        capturePayment()
        return () => {

        }
    }, [])

    return (
        <>
            <Navbar></Navbar>
            <Box sx={{ backgroundColor: "#f6f7ff", minHeight: "90vh", }}>
                <Container maxWidth="xl" sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "88vh" }}>
                    <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
                        <Grid item xs={12} sm={8} md={6} lg={4}>
                            <Box sx={{ boxShadow: "0 5px 15px rgba(0,0,0,.08)", p: { xs: 2, sm: 4 }, borderRadius: "6px" }}>
                                <Box sx={{ textAlign: "center", }}>
                                    {
                                        transactionDetails
                                            ?
                                            <CheckCircleIcon sx={{ fontSize: "60px", color: "green" }}></CheckCircleIcon>
                                            :
                                            <CircularProgress sx={{ width: "50px !important", height: "50px !important", color: "green" }} />
                                    }
                                </Box>
                                <Box sx={{ mt: 1, textAlign: "center" }}>
                                    <Typography sx={{ fontWeight: 500, fontSize: { xs: "20px", sm: "26px" } }}>{transactionDetails ? "Payment success" : "Payment processing"}</Typography>
                                </Box>
                                <Box sx={{ mt: 1, textAlign: "center" }}>
                                    <Typography sx={{ fontWeight: 400, fontSize: { xs: "14px", sm: "16px" } }}>{transactionDetails ? "" : "Please wait while we process your payment"}</Typography>
                                </Box>
                                {
                                    transactionDetails
                                    &&
                                    <Box>
                                        <Box sx={{ mt: 3, textAlign: "center", mb: 3, }}>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", border: "1px solid #dcdcdc" }}>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", p: 1, borderBottom: "1px solid gainsboro" }}>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>Order ID</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>{transactionDetails.id}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", p: 1, borderBottom: "1px solid gainsboro" }}>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>Txn Date</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>{moment(orderItem.create_time).format(APP_DATE_FORMAT)}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", p: 1, borderBottom: "1px solid gainsboro" }}>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>Txn Amount</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>{orderItem.amount.value} {orderItem.amount.currency_code}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", p: 1, borderBottom: "1px solid gainsboro" }}>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>Txn status</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>{transactionDetails.status}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", p: 1, }}>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>New wallet balance</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>{user.wallet.wallet_amount}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ textAlign: "center", pt: 1.5 }}>
                                            <Button onClick={navigateToWallet} variant='contained'>Back to wallet</Button>
                                        </Box>
                                    </Box>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default PaymentSuccess